import { Component, OnInit, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { VoucherService } from "../shared/voucher.service";

@Component({
  selector: 'app-voucherlist',
  templateUrl: './voucherlist.component.html',
  styleUrls: ['./voucherlist.component.css']
})
export class VoucherlistComponent implements OnInit {

  displayedColumns: string[] = ['Id','TransactionId','Voucher No.', 'VoucherType', 'VoucherAmount','ApprovalStatus','Voucher Date', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  ListByApprovalStatus = 0; // selecting approval sp

  constructor(private router: Router, private voucherService: VoucherService) {
    
   }

  ngOnInit() {
    this.getVoucherList();
    this.dataSource.paginator = this.paginator;
  }

  getVoucherList() {
     
    this.voucherService.FetchVoucherList(this.ListByApprovalStatus).subscribe(data => {
      this.dataSource.data = data;
      // console.log(data);
    })
  }

  public AddNew() {
    this.router.navigate(['/voucher']);
  }

  Edit(voucher: any) {
    // this.router.navigate(['/voucher', voucher.Id]);
    this.router.navigate(['/voucher', voucher.TransactionId]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }


}
